<template>
  <div class="flex flex-col items-center justify-center py-12 px-4 text-center">
    <!-- Icon Section -->
    <div class="mb-4">
      <!-- Document Icon -->
      <svg v-if="icon === 'document'" class="h-16 w-16" :class="iconClass" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
      </svg>
      
      <!-- Data Icon -->
      <svg v-else-if="icon === 'data'" class="h-16 w-16" :class="iconClass" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"></path>
      </svg>
      
      <!-- Folder Icon -->
      <svg v-else-if="icon === 'folder'" class="h-16 w-16" :class="iconClass" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"></path>
      </svg>
      
      <!-- Search Icon -->
      <svg v-else-if="icon === 'search'" class="h-16 w-16" :class="iconClass" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
      </svg>
      
      <!-- Custom Icon -->
      <svg v-else-if="icon === 'custom'" class="h-16 w-16" :class="iconClass" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :d="customIcon || ''"></path>
      </svg>
    </div>
    
    <!-- Content Section -->
    <h3 class="text-lg font-medium text-gray-900 mb-2">{{ title }}</h3>
    <p class="text-sm text-gray-500 max-w-md mb-6">{{ message }}</p>
    
    <!-- Action Section -->
    <button
      v-if="showAction"
      type="button"
      class="px-4 py-2 rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2"
      :class="actionClass || 'bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500'"
      @click="$emit('action')"
    >
      {{ actionText }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'EmptyState',
  
  props: {
    icon: {
      type: String as PropType<'document' | 'data' | 'folder' | 'search' | 'custom'>,
      default: 'document'
    },
    customIcon: {
      type: String,
      default: ''
    },
    iconClass: {
      type: String,
      default: 'text-gray-400'
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    showAction: {
      type: Boolean,
      default: false
    },
    actionText: {
      type: String,
      default: 'Action'
    },
    actionClass: {
      type: String,
      default: ''
    }
  },
  
  emits: ['action'],
  
  setup() {
    return {};
  }
});
</script>